import React, { useState } from 'react'
import { useTypedSelector } from 'src/redux/root-reducer'
import { CardImage } from '../BankImage/BankImage'
import { NewCardFlex, PaymentSwitch, SelectPaymentWrapper } from './style'
import { BankCardSvg, PaymentArrow } from 'src/assets/index'
import SwitchPayment from '../paymentSwitch/SwitchPayment'
interface PaymentOption {
  name: 'card' | 'bank' | any
  data: string | 'new'
}

interface SelectProps {
  option: PaymentOption
  setPayWithMethod: (option: PaymentOption) => void
  plan?: any
  // addNewCard?: boolean
  // showBank?: boolean
}

interface SelectedPaymentMethodProps {
  onClick?: () => void
  option: PaymentOption
  setMethod?: (option: PaymentOption) => void
  plan: any
  // addNewCard: boolean;
  // showBank: boolean;
}

const SelectedPaymentMethod = ({
  onClick,
  option,
}: SelectedPaymentMethodProps) => {
  const card = option.data
  const cards = useTypedSelector((state) => state.cards.myCards?.cards)

  const returnCardDetails = () => {
    if (card && card === 'new') {
      return null
    }

    const mainCard = cards?.filter((item: any) => item.id === card)

    if (!mainCard.length) {
      return null
    }

    return mainCard[0]
  }

  const renderCardSection = () => {
    if (card !== 'new' && !returnCardDetails()) {
      return (
        <div
          onClick={onClick}
          style={{ cursor: 'pointer' }}
          className="payment_text_wrapper"
        >
          <p className="payment_text">Choose payment method </p>
          <img src={PaymentArrow} alt="" className="payment_svg" />
        </div>
      )
    }

    if (card === 'new') {
      return (
        <NewCardFlex>
          <CardImage className="card_detail_img" />
          <div>
            <p className="new_card_text">New Card</p>
          </div>
        </NewCardFlex>
      )
    }
    return (
      <NewCardFlex>
        {/* <BankImage
          uri={returnCardDetails()?.card_logo}
         
          
        /> */}
        <img
          src={returnCardDetails()?.card_logo}
          style={{
            height: '45px',
            width: '45px',
            // borderRadius: '50%',
          }}
          alt=""
          className="card_img"
        />
        <div>
          <p color="extraDarkBlue">**** {returnCardDetails()?.card_suffix}</p>
          <p>
            {returnCardDetails()?.expiry_month}/
            {returnCardDetails()?.expiry_year.slice(2, 4)}
          </p>
        </div>
      </NewCardFlex>
    )
  }

  const renderBankSection = () => {
    return (
      <NewCardFlex>
        <div className="svg_wrapper">
          <img src={BankCardSvg} alt="" />
        </div>
        <div className="bank_trf_text">
          <p>Bank Transfer</p>
        </div>
      </NewCardFlex>
    )
  }
  const renderContent = () => {
    switch (option.name) {
      case 'card':
        return renderCardSection()
      case 'bank': {
        return renderBankSection()
      }
      default:
        return null
    }
  }
  const showSwitch = () => {
    if (option.name === 'card' && option.data === 'NULL') {
      return false
    }

    if (option.name === 'card' && !option.data) {
      return false
    }

    return true
  }
  return (
    <>
      <PaymentSwitch>
        {renderContent()}

        {showSwitch() ? (
          <div>
            <p className="switch_btn" onClick={onClick}>
              Switch
            </p>
          </div>
        ) : null}
      </PaymentSwitch>
    </>
  )
}

const PaymentSelect = ({
  option,
  setPayWithMethod,
  plan,
}: // addNewCard = true,
// showBank = true,
SelectProps) => {
  const [showSwitchModal, setShowSwitchModal] = useState(false)

  const handleShowSwitchModal = () => {
    setShowSwitchModal(true)
  }
  return (
    <SelectPaymentWrapper>
      <SelectedPaymentMethod
        option={option}
        onClick={handleShowSwitchModal}
        setMethod={setPayWithMethod}
        plan={plan}
      />

      <SwitchPayment
        showSwitchModal={showSwitchModal}
        setShowSwitchModal={setShowSwitchModal}
        onClick={(op: any) => setPayWithMethod(op)}
        plan={plan}
        // showBank={showBank}
      />
    </SelectPaymentWrapper>
  )
}

export default PaymentSelect
